import BookingDialog from './booking_dialog';

export default BookingDialog;
